import React from 'react';
import {
  Stack,
  TextField,
  Typography,
  Box,
  Paper,
  InputAdornment,
} from '@mui/material';
import {
  PersonOutline,
  PhoneIphone,
  CheckCircleOutline,
  BadgeOutlined,
} from '@mui/icons-material';

function LanNm(lanList, id, fallback) {
  const row = lanList?.find((f) => f.lanId === id);
  return row?.lanNm || fallback;
}

function FindId(props) {
  const ids =
    props.findIdInputs.foundIds?.length > 0
      ? props.findIdInputs.foundIds
      : props.findIdInputs.userId
        ? [props.findIdInputs.userId]
        : [];

  const tfSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      bgcolor: 'grey.50',
      transition: 'background-color 0.2s',
      '&:hover': { bgcolor: 'grey.100' },
      '&.Mui-focused': { bgcolor: '#fff' },
    },
  };

  if (props.findIdInputs.successful) {
    return (
      <Box sx={{ maxWidth: 440, mx: 'auto' }}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <CheckCircleOutline
            sx={{ fontSize: 52, color: '#78CB70', opacity: 0.95 }}
          />
        </Box>
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ fontWeight: 600, mb: 0.5 }}
        >
          조회된 아이디입니다.
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 2.5, lineHeight: 1.6 }}
        >
          아래 아이디로 로그인할 수 있습니다.
        </Typography>
        <Stack spacing={1.25}>
          {ids.map((id) => (
            <Paper
              key={id}
              elevation={0}
              sx={{
                py: 1.5,
                px: 2,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                bgcolor: 'grey.50',
              }}
            >
              <BadgeOutlined sx={{ color: '#78CB70', fontSize: 26 }} />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  letterSpacing: 0.3,
                  userSelect: 'all',
                  fontFamily: 'inherit',
                }}
              >
                {id}
              </Typography>
            </Paper>
          ))}
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 440, mx: 'auto' }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2.5, lineHeight: 1.65 }}
      >
        가입 시 등록한 {LanNm(props.lanList, 'Name', '이름')}과{' '}
        {LanNm(props.lanList, 'Tel', '전화번호')}를 입력해 주세요.
      </Typography>
      <Stack spacing={2}>
        <TextField
          fullWidth
          size="small"
          label={LanNm(props.lanList, 'Name', '이름')}
          value={props.findIdInputs.userNm}
          onChange={(e) => {
            props.setFindIdInputs({
              ...props.findIdInputs,
              userNm: e.target.value,
            });
          }}
          sx={tfSx}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutline sx={{ color: 'action.active', fontSize: 22 }} />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          fullWidth
          size="small"
          label={LanNm(props.lanList, 'Tel', '전화번호')}
          value={props.findIdInputs.userTel}
          type="tel"
          placeholder="010-0000-0000"
          onChange={(e) => {
            props.setFindIdInputs({
              ...props.findIdInputs,
              userTel: e.target.value
                .replace(/[^0-9]/g, '')
                .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                .replace(/(-{1,2})$/g, ''),
            });
          }}
          sx={tfSx}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIphone sx={{ color: 'action.active', fontSize: 22 }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Box>
  );
}

export default FindId;
